import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import {
  addProps,
  addIntlProps,
  renderNothingIfPropFalsy,
} from 'utils/recompose';
import messages from './messages';
import { connect } from 'react-redux';
import {
  fetchAnnouncements,
  closeAnnouncements,
} from 'reducers/announcements/actions';
import {
  unreadMessages,
  readMessages,
  announcementsVisible,
} from 'reducers/announcements/selectors';
import { theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { localStorageKey } from 'constants/values';
import { readLocalStorage } from 'utils/localStorage';
import { orderDashboardPath } from 'utils/paths';

function componentDidMount() {
  this.props.fetchAnnouncements();
}

const mapStateToProps = combineSelectors({
  unreadMessages,
  readMessages,
  announcementsVisible,
  theme,
});

const saveReadMessages = messages => {
  let localStore = readLocalStorage();
  let localReadMessagesIds = localStore.readMessagesIds || [];
  let readMessageIds = messages.map(msg => msg.id);
  localReadMessagesIds = localReadMessagesIds.concat(readMessageIds);
  localStore.readMessagesIds = localReadMessagesIds;
  localStorage.setItem(localStorageKey, JSON.stringify(localStore));
};

const onClickClose = ({
  history,
  location,
  closeAnnouncements,
  unreadMessages,
}) => async event => {
  event.preventDefault();
  saveReadMessages(unreadMessages);
  closeAnnouncements();
  const { from } = location.state || { from: { pathname: orderDashboardPath } };
  history.push(from);
};

const initialState = {
  displayRead: false,
};

const showPreviousMessages = ({ displayRead }) => () => {
  return { displayRead: true };
};

const hasUnread = ({ unreadMessages }) => unreadMessages.length > 0;
const hasRead = ({ readMessages }) => readMessages.length > 0;

const displayReadMessages = ({ displayRead, hasRead, hasUnread }) =>
  (displayRead && hasRead) || !hasUnread;

const prevReadMessagesLink = ({ displayRead, hasRead, hasUnread }) =>
  !displayRead && hasRead && hasUnread;

export const iconContainerStyle = ({ theme }) => ({
  background: theme.palette.secondary,
});

export const headerContainerStyle = ({ theme }) => ({
  background: theme.palette.primary,
});

export const buttonStyle = ({ theme }) => ({
  background: theme.palette.primary,
});

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'announcementLabel',
      'readMore',
      'readAcknowledge',
      'showPrevMessagesLabel',
      'proceedLabel',
      'announcementLabel',
    ],
  }),
  connect(mapStateToProps, { fetchAnnouncements, closeAnnouncements }),
  lifecycle({ componentDidMount }),
  withHandlers({ onClickClose }),
  withStateHandlers(initialState, {
    showPreviousMessages,
  }),
  renderNothingIfPropFalsy('unreadMessages'),
  addProps({ hasRead, hasUnread }),
  addProps({
    displayReadMessages,
    prevReadMessagesLink,
    iconContainerStyle,
    headerContainerStyle,
    buttonStyle,
  }),
);
